import {withTranslation} from "react-i18next";

function CenterHomePage (props) {
    return(
        <h3 style={{textAlign: "center"}}>
            Home Center
        </h3>
    )
}

export default withTranslation()(CenterHomePage);
